import React, { useState } from 'react';
import SurveyForm2 from "../surveyform2/survey_form_2"; // import your survey form
import './Section_3.css';
import { DynamicIcon } from 'lucide-react/dynamic';


function Section3({ sectionConfig, onOpenSurvey }) {

  const [showSurvey, setShowSurvey] = useState(false);
  const handleCloseSurvey = () => {
      setShowSurvey(false);
    };

    const handleButtonClick = (button) => {
  if (button.path === "\/") {
    setShowSurvey(true);
  } else {
    window.location.href = button.path;
  }
};

  if (!sectionConfig) return null;
  const getLucideIcon = (iconName, size =35) => {
               if (!iconName) return null;
               return <DynamicIcon name={iconName} size={size} />;
             };

  const backgroundStyle = getBackground(sectionConfig.heading_bgcolor);
const gridStyle = {
    display: "grid",
    gridTemplateColumns: `repeat(${sectionConfig.itemCount}, 1fr)`,
    gap: "20px",
  };

  return (
    <>
    <section className="section-3">
      <div className={ sectionConfig.isCard ? "main-card" : "main-no-card" }>
        {/* Bouncing Balls – show only if bg_animation is true */}
        {sectionConfig.bg_animation !== false && (
          <>
            <div className="bouncing-ball top-right"></div>
            <div className="bouncing-ball bottom-left"></div>
          </>
        )}

        {/* Heading Section – show only if heading is not empty */}
        {sectionConfig.heading && (
          <h4
            className="section-3-heading"
            style={{ background: backgroundStyle }}
          >
            {sectionConfig.heading}
          </h4>
        )}

        <h1
          className="section-3-title"
          style={{
            WebkitBackgroundClip: "text",
            backgroundImage: backgroundStyle,
            color: sectionConfig.isCard ? "#000": "#FFF"
          }}
        >
          {sectionConfig.title}
        </h1>
        <p className="section-3-subtitle" style={{
            color: sectionConfig.isCard ? "#000": "#FFF"
          }}>{sectionConfig.subtitle}</p>

        {/* Cards – show only if isItemsCardVisible is true */}
        <div className="cards-row" style={gridStyle}>
            {sectionConfig.cards.map((card, idx) => (
              <div key={idx} className="sub-card"
              style={{
          background: sectionConfig.isItemsCardVisible ? "transparent" : "#1f2937ff",
          boxShadow: sectionConfig.isItemsCardVisible ? "0 4px 8px rgba(0,0,0,0.1)" : "none",
        }}
              >
                <div className="sub-card-icon">{getLucideIcon(card.icon)|| '⭐'}</div>

                {/* Number Section – show only if number is not empty */}
                {card.number && (
                  <div className="sub-card-number">{card.number}</div>
                )}

                <div className="sub-card-title" style={{
            color: sectionConfig.isCard ? "#000": "#FFF", whiteSpace: "pre-line"
          }}>
                  <strong>{card.title}</strong>
                </div>
                <div className="sub-card-subtitle" style={{
            color: sectionConfig.isCard ? "#000": "#FFF", whiteSpace: "pre-line"
          }}>{card.subtitle}</div>
              </div>
            ))}
          </div>

        {/* Buttons */}
        {sectionConfig.buttons?.length > 0 && (
          <div className="buttons-3-row">
  {sectionConfig.buttons.map((button, index) => (
    <button
      key={index}
      className={button.primary ? "btn-3 primary" : "btn-3 secondary"}
      style={{ background: button.primary ? backgroundStyle : "" }}
      onClick={() => handleButtonClick(button)}
    >
      {button.name}
    </button>
  ))}
</div>
        )}
      </div>
    </section>

    {/* Survey modal */}
      {showSurvey && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-btn" onClick={handleCloseSurvey}>
              ✖
            </button>
            <SurveyForm2 />
          </div>
        </div>
      )}
    </>
  );
}



function getBackground(bgColors) {
  if (!bgColors || bgColors.length === 0) return "#333"; // fallback
  return bgColors.length === 1
    ? bgColors[0]
    : `linear-gradient(90deg, ${bgColors.join(", ")})`;
}

export default Section3;